import React from 'react'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Slide from '@material-ui/core/Slide'
import Typography from '@material-ui/core/Typography'
import PasswordChange from './PasswordChange'
import PasswordForget from './PasswordForget'


const styles = theme => ({
    paper: {
        padding: theme.spacing.unit*2,
        marginBottom: theme.spacing.unit,
      },
    paperContent: {
        marginTop: theme.spacing.unit*2
        

      },
    headline: {
          boxShadow: '2px 2px 2px',
         // textTransform: 'uppercase'
         paddingBottom: '4px'

      },
})


const PasswordReset = (props) => {
    const { classes } = props
    let someVariable = "message";
    const dynamicProps   = {}
    dynamicProps[someVariable] = 'test';
    return (
            <Slide direction="left" in={true} mountOnEnter unmountOnExit>   
                <Paper className={classes.paper}>
                    <Typography className={classes.headline} variant="title" color='primary' gutterBottom>Kennwort Verwaltung</Typography>
                    <div className={classes.paperContent}>
                            <PasswordChange />
                            <PasswordForget />
                    </div>

                </Paper>
            </Slide>
    )
}

/*
<Paper className={classes.paper}>
            <h3>Account: {authUser.email}</h3>
            <PasswordForgetForm />
            <PasswordChangeForm />
          </Paper>
*/

export default withStyles(styles)(PasswordReset)


// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/PasswordActions.js